import { render, staticRenderFns } from "./violationOfficialDialogModal.vue?vue&type=template&id=d257df7e&scoped=true"
import script from "./violationOfficialDialogModal.vue?vue&type=script&lang=js"
export * from "./violationOfficialDialogModal.vue?vue&type=script&lang=js"
import style0 from "./violationOfficialDialogModal.vue?vue&type=style&index=0&id=d257df7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d257df7e",
  null
  
)

export default component.exports